import React, { useState, useEffect } from 'react'
import './MyOrder.css'
import { db } from '../Firebase'
import { useSelector } from 'react-redux'
import Order1 from '../Components/Order1'

export default function MyOrders() {

    let user = useSelector(state => state.user);
    console.log(user);
    let [orders, setOrders] = useState();

    useEffect(() => {
        db.collection('users')
            .doc(user?.uid)
            .collection('orders')
            .onSnapshot((snapshot) => {
                console.log('in success of snapshot');
                console.log(snapshot.docs);
                setOrders(snapshot.docs.map((doc) => (
                    {
                        id: doc.id,
                        data: doc.data()
                    }
                )))
                console.log(orders)
            })
    }, [])

    return (
        <div className='myOrder'>
            
            <h1>Your Orders {orders?.length}</h1>
            <div className="orders__order">
                {user && orders?.map(order => (
                    <Order1 key={order.id} order={order} />
                ))
                }
            </div>
        </div>
    )
}